import { mapProps } from 'recompose';
import _ from 'lodash';

/*
* omitProps: A high order component that removes props from a component.
*
* When composing many HoCs in to more complex HoCs, many props get introduced in the call chain.
* This HoC is useful for "cleaning" up props before they are finally made available to the wrapped
* component.
 */
const omitProps = (keys) => {
  return mapProps((props) => {
    return _.omit(props, keys);
  });
};


export default omitProps;
